
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lot/[vrm]",
      function () {
        return require("private-next-pages/lot/[vrm].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lot/[vrm]"])
      });
    }
  